module.exports = __webpack_public_path__ + "static/media/PBDQ_Style_Minimalist.40f1c661.png";